import {
  ChangeDetectionStrategy,
  Component,
  output,
  signal,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'

import { BottomDialogComponent } from '../bottom-dialog/bottom-dialog.component'

/** The bottom sheet `AdaptiveDialogService` renders a dialog component in on phones. */
@Component({
  selector: 'app-dialog-sheet',
  template: `
    <app-bottom-dialog
      [visible]="visible()"
      [showDragHandle]="showDragHandle()"
      [focusOnShow]="focusOnShow()"
      [dismissable]="dismissable()"
      [closeOnEscape]="closeOnEscape()"
      (visibleChange)="!$event && dismissed.emit()"
      (hidden)="hidden.emit()"
    >
      <div class="dialog-sheet-content">
        <ng-container #outlet></ng-container>
      </div>
    </app-bottom-dialog>
  `,
  styles: `
    .dialog-sheet-content {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-height: 90dvh;
      overflow-y: auto;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BottomDialogComponent],
})
export class DialogSheetComponent {
  public readonly visible = signal(true)
  public readonly showDragHandle = signal(false)
  public readonly focusOnShow = signal(true)
  public readonly dismissable = signal(true)
  public readonly closeOnEscape = signal(true)
  /** Closed by a swipe, the backdrop or Escape. */
  public readonly dismissed = output<void>()
  public readonly hidden = output<void>()

  @ViewChild('outlet', { read: ViewContainerRef, static: true })
  public readonly outlet!: ViewContainerRef
}
